// extracted by mini-css-extract-plugin
export default {"IconButton":"group-header-expansion-button-module__IconButton__Q02ZOtn"};